import ChevronDown from '@img/icons/icon-chevron-down.svg';
import { Column, Grid } from '@stories/Settings/Grids/Grid.styles';
import React, { useState } from 'react';
import s from './FooterMenu.styles';

export type FooterMenuItem = {
  id: number;
  title: string;
  links: CTAModel[];
};

export interface FooterMenuProps {
  items: FooterMenuItem[];
}

const FooterMenu: React.FC<FooterMenuProps> = ({ items }) => {
  const [activeIndex, setActiveIndex] = useState<number>(-1);

  return (
    <s.Wrapper>
      <Grid.Default>
        <Column.Full>
          <s.Grid>
            {items.map((item, index) => (
              <s.Column key={item.id}>
                <s.TitleAccordian onClick={() => setActiveIndex(index === activeIndex ? -1 : index)}>
                  <span>{item.title}</span>
                  <s.Icon
                    initial={{ rotate: 0 }}
                    animate={index === activeIndex ? { rotate: -180 } : { rotate: 0 }}
                    transition={{
                      duration: 0.3,
                      ease: 'easeInOut',
                    }}
                  >
                    <ChevronDown />
                  </s.Icon>
                </s.TitleAccordian>
                <s.Title>{item.title}</s.Title>
                <s.List
                  key={item.id}
                  initial={{ height: 0 }}
                  animate={index === activeIndex ? { height: 'auto' } : { height: 0 }}
                  transition={{
                    duration: 0.3,
                    ease: 'easeInOut',
                  }}
                >
                  {item.links.map((link) => (
                    <s.Item key={link.id}>
                      <s.Link href={link.url} target={link.target ?? '_self'}>
                        {link.text}
                      </s.Link>
                    </s.Item>
                  ))}
                </s.List>
              </s.Column>
            ))}
          </s.Grid>
        </Column.Full>
      </Grid.Default>
    </s.Wrapper>
  );
};

export default FooterMenu;
